import React from 'react';
import { BarChart } from '../../chart';
import { getHouseholdTitle } from '../../../config';
import './details-chart.scss';

const Household = ({ data }) => {

    if (!data) return null;

    return (
        <div className="details-scb-chart">
            <h2 className="details-scb-chart__heading">Hushåll</h2>
            <p className="details-scb-chart__value">Antal hushåll: {data.total.toLocaleString('sv')} st</p>
            <BarChart 
                valueLabel="Antal hushåll:"
                unit="st"
                total={data.total}
                totalLabel="Andel:"
                data={data.dataItems.map(item => {
                    return {
                        name: getHouseholdTitle(item.title),
                        data: item.value
                    }
                })} dataKeys={[
                    {
                        key: 'set1', 
                        background: '#c34353'
                    },
                    {
                        key: 'set2', 
                        background: '#f2b146'
                    },
                    {
                        key: 'set3', 
                        background: '#83b69c'
                    },
                    {
                        key: 'set4', 
                        background: '#0b3358'
                    },
                    {
                        key: 'set5', 
                        background: '#726454'
                    },
                    {
                        key: 'set6', 
                        background: '#79bafa'
                    },
                    {
                        key: 'set7', 
                        background: '#222'
                    }
                ]} />
        </div>
    );
};

export default Household;